import { ListItemIcon, Menu, MenuItem } from "@material-ui/core";
import React, { FC, useCallback } from "react";
import styled from "styled-components";
import { Logout } from "../../../icons/Logout";
import { HeaderAvatar } from "./HeaderAvatar";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { getAuthState } from "../../auth";
import { getProfileInitialState } from "../../../redux/profileReducer";
import useTranslateMessage from "../../../hooks/useTranslateMessage";

const StyledHeaderUserMenu = styled.div`
  line-height: 0;
`;

interface Props {
  className?: string;
  userName?: string;
  userImage?: string;
  onRequestLogout: () => void;
}

const HeaderUserMenu: FC<Props> = ({
  className,
  userName,
  userImage,
  onRequestLogout,
}) => {
  const t = useTranslateMessage();
  const authState = useSelector(getAuthState());
  const { allowedRoles } = getProfileInitialState();
  const router = useRouter();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const canViewProfile = authState.roles?.some((role) =>
    allowedRoles.includes(role),
  );

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRequestLogout = useCallback(() => {
    handleCloseMenu();
    onRequestLogout();
  }, [onRequestLogout]);

  return (
    <StyledHeaderUserMenu className={className}>
      <HeaderAvatar
        name={userName}
        image={userImage}
        onClick={handleOpenMenu}
        data-cy="header-avatar"
      />

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {canViewProfile && (
          <MenuItem
            onClick={() => {
              router.push("/profile");
            }}
          >
            <span style={{ width: "100%", textAlign: "left" }}>
              {t({ id: "headerUserMenu-profileButton" })}
            </span>
          </MenuItem>
        )}
        <MenuItem onClick={handleRequestLogout} data-cy="header-logout">
          <ListItemIcon>
            <Logout />
          </ListItemIcon>

          {/* Logout */}
          <span>{t({ id: "headerUserMenu-logoutButton" })}</span>
        </MenuItem>
      </Menu>
    </StyledHeaderUserMenu>
  );
};

export { HeaderUserMenu };
